import React, { useState, useEffect } from "react";
import { makeStyles, Button } from "@material-ui/core";
import { useInput } from "react-admin";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import imageCompression from 'browser-image-compression';

const useStyles = makeStyles({
	imageContainer: {
        backgroundPosition: "center",
        backgroundSize: "cover",
        paddingTop: "60%",
        position: "relative",
        borderRadius: 8,
        border: "1px solid #888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
	},
    removeButton: {
        position: "absolute",
        top: 3,
        right: 2,
        width: 21,
        height: 21,
        backgroundColor: "#fff",
        borderRadius: 200,
        border: "1px solid #888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer"
        },
    }
});

export default function RaImagesInput(props) {
    const classes = useStyles();
    const { style } = props;
	const { input: { value, onChange } } = useInput(props);
    
    const [images, setImages] = useState([]);

    const updateImages = images => {
        setImages(images);
        onChange(JSON.stringify(images));
    };

    const addImage = async event => {
        if(event.target.files && event.target.files[0]) {
            const imageFile = event.target.files[0];
            var temp = images.concat([URL.createObjectURL(imageFile)]);
            updateImages(temp);

            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            }
            try {
                const compressedFile = await imageCompression(imageFile, options);
                temp = images.concat([URL.createObjectURL(compressedFile)]);
                updateImages(temp);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const removeImage = index => {
        const imagesArray = images.slice(0, index).concat(images.slice(index + 1));
        updateImages(imagesArray);
    };

    useEffect(() => {
        if(value != null && value !== "") {
            try {
                const imagesArray = JSON.parse(value);
                setImages(imagesArray);
            } catch (e) {}
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, 150px)", gap: 15, ...style }}>
            {images.map((imageUrl, index) => (
                <div
                    className={classes.imageContainer}
                    style={{
                        backgroundImage: `url(${imageUrl})`
                    }}
                >
                    <div className={classes.removeButton} onClick={() => removeImage(index)}>
                        <CloseIcon style={{ fontSize: 16 }} />
                    </div>
                </div>
            ))}

            {images.length < 10 && <Button className={classes.imageContainer} style={{ padding: 0, position: "relative", minHeight: 91 }}>
                <AddIcon style={{ fontSize: 40, color: "#444" }} />
                <input
                    type="file"
                    accept="image/png, image/jpeg"
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0 }}
                    onChange={addImage}
                />
            </Button>}
        </div>
	);
};